import { createCacheStore } from '@lib/utils/cache';
import { OrgEmployeeService } from '@api/OrgEmployeeService';

/** Cached OrgEmployeeService.getAllOrgEmployees(orgId) reads. */
export const orgEmployeesCache = createCacheStore(
    'orgEmployee/allOrgEmployees',
    OrgEmployeeService.getAllOrgEmployees,
);

/** Drops the cached org employees for one org (e.g. after a mutation). */
export const invalidateOrgEmployees = (orgId: string): void => {
    orgEmployeesCache.invalidate(orgId);
};

/** Drops all cached org employee data (when the org key is unknown). */
export const invalidateOrgEmployeeData = (): void => {
    orgEmployeesCache.invalidateAll();
};
